import React from "react";
import { Card, Button, Space } from "antd";
import { LoginOutlined } from "@ant-design/icons";
import { MemberProfile } from "../../../../model/members/MemberProfile";
import { PointOfSaleTransaction } from "../../../../model/pointofsale/PointOfSaleTransaction";
import { MembershipCategory } from "../../../../model/members/MembershipCategory";
import MemberActions from "../MemberActions";
import { MemberProfileMode } from "./modeConfig";

interface QuickActionsProps {
    member: MemberProfile;
    mode: MemberProfileMode;
    pointOfSaleTransactions: PointOfSaleTransaction[];
    membershipCategories: MembershipCategory[];
    onCheckIn: () => void;
    checkingIn: boolean;
    checkInDisabled: boolean;
    onMemberUpdated: () => void;
    onPosTransactionUpdated: () => void;
}

// Left-rail quick actions (staff only): a prominent check-in CTA plus the
// existing MemberActions handlers (take payment / point of sale / activate /
// cancel) rendered as block buttons.
const QuickActions: React.FC<QuickActionsProps> = ({
    member,
    mode,
    pointOfSaleTransactions,
    membershipCategories,
    onCheckIn,
    checkingIn,
    checkInDisabled,
    onMemberUpdated,
    onPosTransactionUpdated,
}) => {
    return (
        <Card size="small" title="Quick actions">
            <Space direction="vertical" style={{ width: "100%" }} size={8}>
                {mode.checkInButton && (
                    <Button block type="primary" icon={<LoginOutlined />} loading={checkingIn} disabled={checkInDisabled} onClick={onCheckIn}>
                        Check in
                    </Button>
                )}
                {mode.actions && (
                    <MemberActions
                        embedded
                        canCancel={mode.cancelMembership}
                        member={member}
                        pointOfSaleTransactions={pointOfSaleTransactions}
                        membershipCategories={membershipCategories}
                        onMemberUpdated={onMemberUpdated}
                        onPosTransactionCompleted={onPosTransactionUpdated}
                    />
                )}
            </Space>
        </Card>
    );
};

export default QuickActions;
